import React, { useMemo } from 'react';
import { Bubble } from 'tea-component';
import { openWindowUrl } from '@op/utils/url';
import './index.scss';
import { getMonitoringSource } from '@op/components/TableCommonHook/utils';
import {
  MonitorSourceItemType,
  AccountCategoryType,
} from '@op/components/TableCommonHook/types';
import useLanguage from '@op/hooks/useLanguage';

export default function MonitoringShow({
  monitor_source,
  className,
}: {
  monitor_source: Array<MonitorSourceItemType>;
  className?: string;
}) {
  const { formatMessage, isEn } = useLanguage();
  const { keyword, external, accountCategories, list } = useMemo(() => {
    const data = getMonitoringSource(monitor_source);

    return data;
  }, [monitor_source]);

  function openUrl(url: string) {
    openWindowUrl(url);
  }

  const getItemElement = (
    item: MonitorSourceItemType,
    isLast: boolean,
    key: string,
  ) => {
    const text =
      item.type?.toLocaleUpperCase?.() === 'DISCORD-PRIVATE'
        ? 'PRIVATE'
        : `${item.type}`;

    const typeText = item.type && `(${text})`;
    const isKeyword = key !== 'account';
    if (isKeyword) {
      return (
        <span key={item.name} className="is-item-keyword">
          {item.name} {typeText} {isLast ? '' : ', '}
        </span>
      );
    }
    return (
      <p
        key={item.name}
        className="dbo-tablecommon-line--link"
        onClick={() => item.url && openUrl(item.url)}
      >
        {item.name} {typeText}
      </p>
    );
  };

  const renderCategorySection = (category: AccountCategoryType) => {
    const { list: items, textInfo } = category;
    if (items.length === 0) return null;

    const title = isEn ? textInfo.text : textInfo.textCN;

    return (
      <React.Fragment key={category.key}>
        <p>{title}</p>
        <p>
          {items.map((item, index) =>
            getItemElement(item, index === items.length - 1, item.key),
          )}
        </p>
      </React.Fragment>
    );
  };

  const getBubbleContent = () => {
    const ele = [];

    // Keyword
    if (keyword.length > 0) {
      ele.push(<p key="keyword">{formatMessage({ id: 'by Keyword' })}</p>);
      ele.push(
        <p key="keyword-Info" className="dbo-bubble-line-keyword">
          {keyword.map((item, index) =>
            getItemElement(item, index === keyword.length - 1, item.key),
          )}
        </p>,
      );
    }

    // Account Categories
    accountCategories.forEach((category) => {
      const section = renderCategorySection(category);
      if (section) {
        ele.push(section);
      }
    });

    // External
    if (external.length > 0) {
      ele.push(
        <p key="external">
          {formatMessage({ id: 'by External Data Sources' })}
        </p>,
      );
      ele.push(
        <p key="external-Info" className="dbo-bubble-line-keyword">
          {external.map((item, index) =>
            getItemElement(item, index === external.length - 1, item.key),
          )}
        </p>,
      );
    }

    return ele.length === 0 ? null : ele;
  };

  if (!list || !Array.isArray(list)) {
    return null;
  }

  return (
    <Bubble
      dark
      closeOnScroll
      content={getBubbleContent()}
      overlayClassName="dbo-monitoring-show"
    >
      <span className={`monitoring-show-wrapper ${className}`}>
        {list.map((item, index) =>
          getItemElement(item, index === list.length - 1, item.key),
        )}
      </span>
    </Bubble>
  );
}
